import { PUT_INFO_CARDS_START } from '../../types';

export const put_info_cards = (payload) => ({
  type: PUT_INFO_CARDS_START,
  payload,
});
